<template>
  <div class="__MyAccount-Password">
    <Button :label="$t('Change password')" @click="onClick" />

    <MyAccountPasswordDialogChange v-model="dialogChangePassword" />
  </div>
</template>

<script>
import Button from '@design-system/components/Button.vue';

import CTitle from '@/components/uikit/CTitle';

import MyAccountPasswordDialogChange from '@/pages/Preferences/MyAccountPasswordDialogChange';

const messages = {
  en: {
    'Change password': 'Change Password',
  },
  ja: {
    'Change password': 'パスワードを変更',
  },
};

export default {
  name: 'MyAccountPassword',
  components: { Button, CTitle, MyAccountPasswordDialogChange },
  i18n: { messages },
  data() {
    return {
      dialogChangePassword: false,
    };
  },
  methods: {
    onClick() {
      this.dialogChangePassword = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.__MyAccount-Password {
  margin-bottom: $space-xl;
}
</style>
